export function resouseDownloadHelper(url: string, filename: string) {
  // if (document.getElementById('iframe')) {
  //   document.body.removeChild(document.getElementById('iframe'));
  // }
  // const iframe = document.createElement('iframe');
  // iframe.style.display = 'none';
  // iframe.id = 'iframe';
  // iframe.setAttribute(
  //   'src',
  //   'https://course-assets.alo7.com/kellis-ng/assets/download.html'
  // );
  // document.body.appendChild(iframe);
  // iframe.onload = () => {
  //   iframe.contentWindow.postMessage(
  //     {
  //       url,
  //       fileName,
  //     },
  //     '*'
  //   );
  // };

  fetch(url)
    .then(r => r.blob())
    .then(res => {
      nx.blob2down(res, { filename });
    });
}
